<template>
  <el-form-item
    v-if="canAction('addPowerOfAttorney')"
    label="Информация о доверенности"
    class="po-attorney"
  >
    <loader-wrapper :loading="loading">
      <el-row class="attorney">{{ fio }}</el-row>
      <el-link type="primary" @click="showModal">
        {{ viewFiles ? 'Изменить' : 'Добавить документ' }}
      </el-link>
      <el-dialog :visible.sync="dialog" :width="isMobile ? '90%' : '60%'">
        <el-row slot="title" class="poa-title">
          Информация о доверенности
        </el-row>
        <el-row class="name">
          Фамилия Имя Отчество в родительном падеже
        </el-row>
        <el-row class="name-block" :gutter="40">
          <el-col :xs="24" :sm="12">
            <el-input
              v-model="document.comment"
              placeholder="ФИО в родительном падеже"
            />
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-button type="primary" :loading="loading" @click="onUpdate">
              Сохранить
            </el-button>
          </el-col>
        </el-row>
        <el-row class="num-block">
          {{ number ? 'Номер доверенности: ' + number : number }}
        </el-row>
        <upload-document-modal
          ref="uploadDocumentModal"
          :name-document="dataEdit.documentType"
          :data-edit="dataEdit"
          :source-id="dataEdit.sourceId"
          :object-data="objectData"
          :need-additional="true"
          :advanced-info="advanceInfoData"
          @ready="onReady"
        />
      </el-dialog>
    </loader-wrapper>
  </el-form-item>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { filesValidateMixinChildActions } from '@/mixins/filesValidateMixin'
import { mapGetters } from 'vuex'
import LoaderWrapper from '@/components/Shared/LoaderWrapper'
import UploadDocumentModal from '@/components/Upload/UploadDocumentModal'

const Doc = RepositoryFactory.get('document')

export default {
  name: 'PowerOfAttorney',
  components: { UploadDocumentModal, LoaderWrapper },
  mixins: [filesValidateMixinChildActions],
  data() {
    return {
      document: { comment: '' },
      dialog: false,
      loading: false,
      filesValidateMixinData: {
        refComponentName: 'uploadDocumentModal',
        errorMessage: 'Доверенность',
        childFilesCountProperty: 'countFiles',
      },
      advanceInfoData: {
        inn: {
          title: 'ИНН',
          fieldName: 'inn',
        },
        org_name: {
          title: 'Наименование',
          fieldName: 'short_name',
        },
      },
    }
  },
  computed: {
    ...mapGetters({ user: 'userProfile/getByKey' }),
    objectData() {
      const data = this.user('current')

      if (data && data.organization) {
        data.inn = data.organization.inn
        data.short_name = data.organization.short_name
      }

      return data || {}
    },
    dataEdit() {
      return Object({
        sourceModelName: 'userOrgs',
        sourceId: this.objectData ? this.objectData.id : 0,
        documentType: 'proxy_doc',
      })
    },
    viewFiles() {
      return this.document && this.document.files && this.document.files.length
    },
    number() {
      if (!this.document) {
        return ''
      }
      const { number, document_create_date } = this.document
      const date = this.dateToFormat(
        document_create_date,
        'onlyDateWithFullTear',
      )

      return number || date ? `№${number || '-'} от ${date || '-'} ` : ''
    },
    fio() {
      const fio =
        this.document && this.document.comment
          ? `на ${this.document.comment}`
          : ''

      return this.number || fio
        ? `Доверенность ${this.number}${fio}`
        : 'Нет данных'
    },
  },
  mounted() {
    this.getDoc()
  },
  methods: {
    onReady(doc) {
      this.document = { ...this.document, ...doc }
    },
    onUpdate() {
      if (this.document && this.document.id) {
        this.loading = true
        const { comment, id } = this.document

        Doc.update(id, { comment })
          .then(res => {
            const { status, data } = res

            if (status === 200 && data) {
              this.onReady(data)
              this.$message.success('Сохранено успешно')
            }
          })
          .catch(err => this.errHandler(err))
          .finally(() => (this.loading = false))
      }
    },
    showModal() {
      this.dialog = true
    },
    getDoc() {
      this.loading = true
      Doc.getDocument(
        this.dataEdit.sourceModelName,
        this.dataEdit.sourceId,
        this.dataEdit.documentType,
      )
        .then(res => {
          const { status, data } = res

          if (status === 200 && data && data.length) {
            this.getApproveOneDoc(data)
          }
        })
        .catch(err => this.errHandler(err))
        .finally(() => (this.loading = false))
    },
    getApproveOneDoc(doc) {
      let documentItem

      for (let key in doc) {
        if (documentItem === undefined) {
          documentItem = doc[key]
        }
        if (doc[key].approve_status.length !== 0) {
          documentItem = doc[key]
        }
      }

      if (documentItem) {
        this.onReady(documentItem)
      }
    },
  },
}
</script>

<style lang="sass">
.po-attorney
  color: #000
  .attorney
    font-size: 14px
  .el-dialog__header
    padding: 30px 50px 25px
  .el-dialog__body
    color: #000
    padding: 0 50px 50px
  .poa-title
    font-size: 16px
    font-weight: bold
  .name
    font-size: 18px
    margin-bottom: 20px
  .name-block
    margin-bottom: 50px
    button
      width: 200px
  .num-block
    margin-bottom: 25px
    font-size: 16px
</style>
